<script setup lang="ts">
import { ButtonType } from '../types/common';

const props = withDefaults(defineProps<{
    modelValue: boolean,
    loading?: boolean,
    openIcon?: string,
    closedIcon?: string,
    tooltip?: string
}>(), {
    loading: false,
    openIcon: 'pi pi-sign-in',
    closedIcon: 'pi pi-sign-in'
});

const emit = defineEmits<{(event: 'update:modelValue', value: boolean): void}>();

const { t } = useI18n();

const togglePanel = () => {
    emit('update:modelValue', !props.modelValue);
};
</script>

<template>
    <div class="flex items-start h-full">
        <div class="collapsible-panel h-full" :class="{ 'collapsible-panel--open': modelValue }">
            <slot />
        </div>

        <VButton
            v-if="!modelValue"
            v-tooltip="t('workflows.excel.showMappingValues')"
            :type="ButtonType.LINK_PRIMARY"
            :icon="closedIcon"
            class="collapsible-panel-toggle collapsible-panel-toggle--closed"
            :loading="loading"
            @click="togglePanel"
        />
    </div>
</template>

<style scoped>
.collapsible-panel {
    width: 0;
    opacity: 0;
    overflow: hidden;
    transition: width 0.3s ease, opacity 0.2s ease;
}

.collapsible-panel--open {
    width: 320px;
    opacity: 1;
    padding-right: 0.25rem;
    overflow-y: auto;
}

.panel-header {
    white-space: nowrap;
}

.collapsible-panel-toggle :deep(.p-button-icon) {
    transform: rotate(180deg);
    transition: transform 0.2s ease;
}

.collapsible-panel-toggle--closed :deep(.p-button-icon) {
    transform: rotate(0deg);
}

:deep(.p-button) {
    padding-left: 8px;
}
</style>
